<template>
   <div>
    <loader :is-visible="isLoading"></loader>
    <div class="container">
        <div class="container-post">
            <div class="form-modal">
                <!-- <form @submit.prevent="addEvent"> -->
                    <div class="grid-modal"> 
                       <div class="section-modal">
                            <div class="wrapper">
                                <p>Banner</p>
                                <input id="bannerUpload" type="file" accept="image/*" @change="onAddFile($event, 'banner')" hidden> 
                                <div class="mg-top1">
                                    <img class="imgUpload" v-if="bannerImgUrl" :src="bannerImgUrl" alt="">
                                    <button class="btn-upload mg-top1 mg-right" @click="chooseFiles('banner')">Choose</button>
                                </div>
                                <div class="mg-top">
                                    <div>
                                        <p style="font-weight: bold">Select Date</p>
                                        <!-- <datepicker placeholder="Select Date" :use-utc="true" v-model="eventStart" :disabledDates="state.disabledDates"></datepicker> -->
                                        <date-picker class="mg-top1" v-model="eventDate" value-type="date" range type="datetime"></date-picker>
                                    </div>
                                    <!-- <div class="date--picker">
                                        <p>End Date</p>
                                        <datepicker placeholder="Select Date" v-model="eventEnd" :disabledDates="state.disabledDates"></datepicker>
                                    </div> -->
                                </div>
                                <div class="input-data mg-top">
                                    <input type="text" required v-model="title">
                                    <div class="underline"></div>
                                    <label>Title</label>
                                </div>
                                <div class="mg-top">
                                    <label>Description</label>
                                    <quill-editor
                                        class="mg-top1"
                                        v-model="description"
                                        :options="editorOption"
                                        @change="onEditorChange($event)"
                                    />
                                </div>
                            </div>
                       </div>

                        <div class="section-modal">
                            <div class="form-modal__image--reset">
                                <button  class="close" @click="back()"></button>
                                <p>Thumbnails</p>
                                <input id="thumbnailUpload" type="file" accept="image/*" @change="onAddFile($event, 'thumbnail')" hidden>
                                <div class="mg-top1">
                                    <img class="imgUpload" v-if="thumbnailImgUrl" :src="thumbnailImgUrl" alt="">
                                    <button class="btn-upload mg-top1 mg-right" @click="chooseFiles('thumbnail')">Choose</button>
                                    <!-- <p class="mg-top1">{{ thumbnailImgUrl }}</p> -->
                                </div>
                                <div class="mg-top1">
                                    <p>Featured</p>
                                    <select class="select-css" style="width:100%" name="" id="" v-model="featured">
                                        <option value="" disabled selected>Select Featured :</option>
                                        <option :value="true">Show</option>
                                        <option :value="false">Hide</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>        
                    <div class="btn-heading">
                        <p class="mg-top" v-if="errors.length">
                            <b>Please correct the following error(s):</b>
                            <ul>
                                <li class="red" v-for="(error,index) in errors" :key="index">{{ error }}</li>
                            </ul>
                        </p>

                        <button class="btn-add mg-top1"  @click="validation(id != 0 ? 'update' : 'add')">
                            <!-- Add Post -->
                            {{id != 0? 'Update' : 'Add'}} Post
                        </button>
                    </div>     
                <!-- </form> -->
            </div>
        </div>
    </div>
   </div>
</template>

<script>
import Loader from './../components/Loader.vue';
// import Datepicker from 'vuejs-datepicker';
import DatePicker from 'vue2-datepicker';
import alert from './../commons/alert.helper';
import moment from 'moment';
import axios from 'axios';
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html'

import 'vue2-datepicker/index.css';

import auth from '@/service/auth.js'

export default {
    name: "PostAgendaForm",
    data() {
        return {
            isLoading: false,
            showModal: false,
            title: '',
            description: '',
            featured: '',
            bannerImage: null,
            bannerImgUrl : null,
            thumbnailImage: null,
            thumbnailImgUrl: null,
            id: '',
            eventStart: '',
            eventEnd: '',
            eventDate: [],
            editorOption: {},
            errors: []
        }
    },
    methods: {
        convert(val) {
            let config = { inlineStyles: true }
            let converter = new QuillDeltaToHtmlConverter(val.ops, config)
            let html = converter.convert()
            this.descConvert = html
        },
        onEditorChange({ quill}) {
            this.convert(quill.editor.delta)
        },
        validation(type) {
            this.errors = []
            
            if (!this.bannerImage) this.errors.push('* Image Banner required')
            if (!this.thumbnailImage) this.errors.push('* Image Thumbnail required')
            if (!this.title) this.errors.push('* Title required')
            if (!this.description) this.errors.push('* Description required')
            if (!this.eventDate) this.errors.push('* Date required')
            // if (!this.eventStart) this.errors.push('* Date required')
            // if (!this.eventEnd) this.errors.push('* Date required')
            

            if (this.errors.length > 0) {
                return
            } else if (type === 'add') {
                this.addEvent()
            } else if (type === 'update') {
                this.updateEvent()
            }
        },
        async addEvent() {
             const res = await auth.checkAuth(this.$route.fullPath)
            if (res == false) {
                localStorage.clear()
                alert.failed('Unauthorized Token', () => this.$router.push('/login'))
            } else {
                try {
                    this.isLoading = true
                    const formData = new FormData()
                    
                    // let startDate = moment(this.eventStart).format()
                    // let endDate = moment(this.eventEnd).format()

                    let startDate = moment(this.eventDate[0]).format()
                    let endDate = moment(this.eventDate[1]).format()
    
                    formData.append('banner', this.bannerImage)
                    formData.append('thumbnail', this.thumbnailImage)
                    formData.append('title', this.title)
                    formData.append('description', this.descConvert)
                    formData.append('event_start_date', startDate)
                    formData.append('event_end_date', endDate)
                    formData.append('featured', this.featured)
    
                    const response = await axios.post('/content/event', formData)
                    this.isLoading = false
    
                    console.log(response)
                    if(response.status == 200) {
                        alert.success('Add data success', () => this.$router.go(-1))
                    }
    
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async getDataEvent(id) { 
            
            try {
                const response = await axios.get(`/content/event/${id}`)
                console.log('data', response)

                this.bannerImage = response.data.banner
                this.bannerImgUrl = response.data.banner
                this.thumbnailImage = response.data.thumbnail
                this.thumbnailImgUrl = response.data.thumbnail
                this.title = response.data.title
                this.description = response.data.description
                this.featured = response.data.featured.Bool
                // this.eventStart = new Date(response.data.event_start_date)
                // this.eventEnd = new Date (response.data.event_end_date)
                this.eventDate.push(new Date(response.data.event_start_date))
                this.eventDate.push(new Date (response.data.event_end_date))
                // this.eventDate = response.data.event_start_date

            } catch (error) {
                console.log(error)
            }
        },
        async updateEvent() {
            const res = await auth.checkAuth(this.$route.fullPath)
            if (res == false) {
                localStorage.clear()
                alert.failed('Unauthorized Token', () => this.$router.push('/login'))
            } else {
                try {
                    this.isLoading = true
                    const formData = new FormData()
                    
                    // let startDate = moment(this.eventStart).format()
                    // let eventDate = moment(this.eventEnd).format()

                    let startDate = moment(this.eventDate[0]).format()
                    let endDate = moment(this.eventDate[1]).format()
    
                    formData.append('event_id', this.id)
                    formData.append('banner', this.bannerImage)
                    formData.append('thumbnail', this.thumbnailImage)
                    formData.append('title', this.title)
                    formData.append('description', this.descConvert)
                    formData.append('event_start_date', startDate)
                    formData.append('event_end_date', endDate)
                    formData.append('featured', this.featured)
    
                    const response = await axios.patch(`/content/event/${this.id}`, formData)
                    this.isLoading = false
    
                    console.log(response)
                    if(response.status == 200) {
                        alert.success('Add data success', () => this.$router.go(-1))
                    }
    
                } catch (error) {
                    console.log(error)
                    this.isLoading = false
                    alert.failed('Update data failed')
                }
            }
        },
        onAddFile (e, type) {
            let splitName = e.target.files[0].name.split('.')
            let nameTemp = ''
            let typeFile = ''

            splitName.forEach((item, index) => {
                if (index == 0) {
                    nameTemp = item
                } else if (index+1 != splitName.length) {
                    nameTemp = nameTemp + '.' + item
                } else if (index+1 == splitName.length) {
                    typeFile = '.' + item
                }
            });

            let date = moment().format('DD-MM-YYYY hh:mm:ss')
            let newName = `${nameTemp} ${date}${typeFile}`
            const myNewFile = new File([e.target.files[0]], newName, {type: e.target.files[0].type});

            if (type === 'banner') {
                this.bannerImage = myNewFile
                this.bannerImgUrl = URL.createObjectURL(this.bannerImage)
                console.log('bannerFile', this.bannerImage)
                console.log('bannerName', this.bannerImgUrl)
            } else if (type === 'thumbnail') {
                this.thumbnailImage = myNewFile
                this.thumbnailImgUrl = URL.createObjectURL(this.thumbnailImage)
                console.log('thumbFile', this.thumbnailImage)
                console.log('thumbName', this.thumbnailImgUrl)
            }
        },
        chooseFiles(type) {
            if (type === 'banner') {
                document.getElementById("bannerUpload").click()
            } else if (type === 'thumbnail') {
                document.getElementById("thumbnailUpload").click()
            }
        },
        back() {
            this.$router.go(-1)
        }
    },
    components: {
        // Datepicker,
        DatePicker,
        Loader
    },
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill
      }
    },
    created() {
        this.id = this.$route.params.id
        if(this.id != 0) {
            this.getDataEvent(this.id);
        }
    }
}
</script>